import { combineReducers } from "redux";
import chargeReducer from "./chargeReducer";
import formDataReducer from "./formDataReducer";
import redirectionReducer from "./redirectionReducer";
import upiReducer from "./upiReducer";
import cardReducer from "./cardReducer";
import popupReducer from "./popupReducer";
import otpReducer from "./otpReducer";
import recurringReducer from "./recurringReducer";

const rootReducer = combineReducers({
  upiReducer,
  chargeReducer,
  redirectionReducer,
  formDataReducer,
  cardReducer,
  popupReducer,
  otpReducer,
  recurringReducer
});

export default rootReducer;
